import BaseMygocuApiService from './BaseMygocuApiService';

const USUARIO_API_VERSION = 'v1';
const USUARIO_API_BASEPATH_URL = '/agrupaciones/' + USUARIO_API_VERSION;

class AgrupacionesApiService {
  async getResumenAgrupaciones(titulo) {
    const params = {};
    if (titulo) {
      params.titulo = titulo;
    }
    return await BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL, params);
  }

  async getAgrupacion(uri, codigo, codigoPrevisualizacion) {
    const params = {};
    if (codigo) {
      params.codigo = codigo;
    }
    if (codigoPrevisualizacion) {
      params.codigoPrevisualizacion = codigoPrevisualizacion;
    }
    return await BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat(`/${uri}`), params);
  }

  async getAgrupacionBuilderModule(uri, codigo, codigoPrevisualizacion) {
    const params = {};
    if (codigo) params.codigo = codigo;
    if (codigoPrevisualizacion) params.codigoPrevisualizacion = codigoPrevisualizacion;

    return await BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat(`/${uri}/builderModules`), params);
  }

  /**
   * Guarda el email en los leads de un agrupacion
   *
   * @param {string} uri uri de la agrupacion
   * @param {Object} vgLeadDTO Datos del lead a guardar
   * @returns {Promise<*>} 200-OK si el lead fue guardado correctamente
   */
  async guardarLead(uri, vgLeadDTO) {
    return await BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat(`/${uri}/leads`), vgLeadDTO);
  }
}

export default new AgrupacionesApiService();
